import { ActionTree, GetterTree, MutationTree } from 'vuex';
import HomeSmartApi from '@/plugins/HomeSmartApi';
import { Permission } from '@/modules/backend/Entities/Permission';
import { User } from '@/modules/backend/Entities/User';
import { EditPermissionData } from '@/modules/backend/Dto/EditPermissionData';

interface State {
  IsLoaded: boolean;
  Permissions: Permission[];
}

export const state: State = {
  IsLoaded: false,
  Permissions: []
};

export const getters: GetterTree<State, unknown> = {
  Permissions: (store): Permission[] => store.Permissions,

  HasAccess: (store, gtr, rootState, rootGetters) => (permission: string): boolean => {
    const isAdmin = rootGetters['app/auth/IsAdmin'];

    if (isAdmin) {
      return true;
    }

    const actualPermission = store.Permissions
      .find((item) => item.is(permission));

    if (!actualPermission) {
      return true;
    }

    const info: User = rootGetters['app/auth/Info'];

    if (!info) {
      return false;
    }

    return actualPermission.isAccess(info.getRoles());
  }
};

export const mutations: MutationTree<State> = {
  Permissions: (store, payload: Permission[]) => {
    store.Permissions = payload;
  },
  Add: (store, payload: Permission) => {
    store.Permissions = store.Permissions.concat(payload);
  },
  Edit: (store, payload: Permission) => {
    store.Permissions = store.Permissions.map((item) => {
      if (item.is(payload.getPermission())) {
        return payload;
      }
      return item;
    });
  }
};

export const Permissions: ActionTree<State, unknown> = {
  List: async (context): Promise<Permission[]> => {
    if (context.state.IsLoaded) {
      return context.getters.Actions;
    }
    const response: Permission[] = await HomeSmartApi.Permissions.List();
    context.commit('Permissions', response);
    context.state.IsLoaded = true;
    return response;
  },
  Update: async (context, payload: EditPermissionData): Promise<void> => {
    const result: Permission = await HomeSmartApi.Permissions.Update(payload);
    context.commit('Edit', result);
  }
};

export const permissions = {
  namespaced: true,
  state,
  actions: Permissions,
  getters,
  mutations
};
